import { useState } from 'react'
import { Link } from 'react-router-dom'
import ModalForm from '../Form/ModalForm.jsx'
import './Footer.css'

const EMAIL = 'info@cit-neurosfera.ru'
const PHONE = '+7 937 06 09 009'

export default function Footer() {
  const [copied, setCopied] = useState('')

  async function copy(value, label) {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(label)
      window.setTimeout(() => setCopied(''), 1800)
    } catch {
      setCopied('')
    }
  }

  return (
    <footer className="footer__container">
      <div className="footer__column">
        <p>© ЦИТ Нейросфера</p>
        <Link className="footer__privacyLink" to="/privacy">Политика конфиденциальности</Link>
      </div>

      <div className="footer__contactGroup">
        <span>Для обратной связи и сотрудничества</span>
        <button className="footer__copy" type="button" onClick={() => copy(EMAIL, 'email')}>{EMAIL}</button>
        {copied === 'email' && <p className="footer__copied">Адрес скопирован</p>}
      </div>

      <div className="footer__contactGroup">
        <span>Связаться с нами</span>
        <a href="tel:+79370609009">{PHONE}</a>
        <ModalForm
          triggerText="Техническая поддержка"
          requestType="Техническая поддержка сайта"
          messagePrefix="Обращение в техническую поддержку сайта Нейросфера."
          submitText="Отправить обращение"
          successText="Обращение отправлено"
          triggerClassName="footer__support"
        />
      </div>
    </footer>
  )
}
